module.exports = __webpack_public_path__ + "static/media/top.8ae8339c.png";